// locationApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { createExtendedTokenBaseQuery } from './baseQuery';
import { ApiEndpoints } from '../../services/ApiUrls';
import { Location } from '../../types/asset.types';

export interface LocationPaginatedResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Location[];
}

export interface LocationFilter {
  search?: string;
  company?: string;
  siteId?: string;
}

export const companylocationApi = createApi({
  reducerPath: 'companylocationApi',
  baseQuery: createExtendedTokenBaseQuery(''),
  tagTypes: ['Location'],
  endpoints: (builder) => ({
    getLocations: builder.query<LocationPaginatedResponse, LocationFilter | void>({
      query: (filter = {}) => {
        const params = new URLSearchParams();
        if (filter) {
          if (filter.search) params.append('search', filter.search);
          if (filter.company) params.append('company', filter.company);
          if (filter.siteId) params.append('site', filter.siteId);
        }
        return { url: ApiEndpoints.companylocation.list, params };
      },
      providesTags: ['Location'],
    }),
  }),
});

export const { useGetLocationsQuery } = companylocationApi;
